import React from "react";
import PlayItem from "./PlayItem";
import SoundItem from "./SoundItem";
import { isBrowser,isMobile } from 'react-device-detect';

import PortraitControlBar from "./PortraitControlBar";

// import PlayMobileItem from "./PlayMobileItem";

export default function ControlBar(props){

    return(
        
        <div>
            
            {/* <TimelineBar onPlayClick={props.onPlayClick} seekToFrame={props.seekToFrame}progress={props.progress} /> */}
            <PlayItem playState={props.playState} onClick={props.onPlayClick}/>
            <SoundItem audioChanged={props.audioChanged} onClick={props.onMuteClick}/>
                        {/* <TimelineBar onClick={props.onClick}/> */}

        </div>
    )
}

// responsive-control-bar